import * as Common from "@sp-crm/core";
import { InputFormBlock } from "components/app/input-form-block";
import { PhoneInputE164 } from "components/shared/phone-input-e164";
import { AutosavingInput } from "components/ui/autosaving-input";
import { AutosavingStateInput } from "components/ui/autosaving-state-input";
import { Checkbox } from "components/ui/checkbox";
import * as React from "react";
import { Header } from "../../header";
import { LocaleContext } from "../../locale-provider/locale-provider";
import { Setting } from "../../setting";

interface Props {
    placement: Common.IPlacement;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
    onFieldChange: (fieldName: string, newValue: any) => void;
}

const shouldShow = (placement: Common.IPlacement): boolean => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
    if ((window as any).__placement_crm_show_poa) {
        return true;
    }
    if (!placement) {
        return false;
    }
    if (placement.hasPowerOfAttorney || placement.powerOfAttorneySameAsBestContact) {
        return true;
    }
    if (placement.powerOfAttorney) {
        let valueDefined = false;
        Object.keys(placement.powerOfAttorney).forEach(k => {
            if (k === "_id" || k === "id") {
                return;
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
            const val = (placement.powerOfAttorney as any)[k];
            if (
                (val !== null &&
                    val !== undefined &&
                    val !== "" &&
                    val !== false &&
                    !Array.isArray(val)) ||
                (Array.isArray(val) && val.length > 0)
            ) {
                valueDefined = true;
            }
        });
        return valueDefined;
    }
    return false;
};

export const LegacyPowerOfAttorney: React.FunctionComponent<Props> = props => {
    if (!shouldShow(props.placement)) {
        return null;
    }
    let poaForm = <span />;
    if (
        props.placement.hasPowerOfAttorney &&
        !props.placement.powerOfAttorneySameAsBestContact
    ) {
        poaForm = (
            <LocaleContext.Consumer>
                {locale => (
                    <div id="client-poa-form">
                        <div className="flex space-x-4">
                            <AutosavingInput
                                label="Name"
                                initial={props.placement.powerOfAttorney.name}
                                onCommit={newVal =>
                                    props.onFieldChange("powerOfAttorney.name", newVal)
                                }
                            />
                            <AutosavingInput
                                label="Relationship"
                                initial={props.placement.powerOfAttorney.relationship}
                                onCommit={newVal =>
                                    props.onFieldChange(
                                        "powerOfAttorney.relationship",
                                        newVal,
                                    )
                                }
                            />
                        </div>
                        <div className="flex space-x-4">
                            <PhoneInputE164
                                label="Cell phone number"
                                initial={Common.toPhoneNumberE164(
                                    props.placement.powerOfAttorney.cellPhone,
                                )}
                                onCommit={newVal =>
                                    props.onFieldChange(
                                        "powerOfAttorney.cellPhone",
                                        newVal,
                                    )
                                }
                            />
                            <PhoneInputE164
                                label="Phone number (other)"
                                initial={Common.toPhoneNumberE164(
                                    props.placement.powerOfAttorney.phone1,
                                )}
                                onCommit={newVal =>
                                    props.onFieldChange("powerOfAttorney.phone1", newVal)
                                }
                            />
                        </div>
                        <AutosavingInput
                            label="Email"
                            initial={props.placement.powerOfAttorney.email1}
                            onCommit={newVal =>
                                props.onFieldChange("powerOfAttorney.email1", newVal)
                            }
                        />
                        <Setting name="emailOptOut">
                            <Checkbox
                                checked={props.placement.powerOfAttorney.email1OptOut}
                                label="Email Opt-out (for bulk/newsletter emails)"
                                onChange={e =>
                                    props.onFieldChange(
                                        "powerOfAttorney.email1OptOut",
                                        e.target.checked,
                                    )
                                }
                            />
                        </Setting>
                        <AutosavingInput
                            label="Address"
                            initial={props.placement.powerOfAttorney.address1}
                            onCommit={newVal =>
                                props.onFieldChange("powerOfAttorney.address1", newVal)
                            }
                        />
                        <div className="flex space-x-4">
                            <AutosavingInput
                                label="City"
                                initial={props.placement.powerOfAttorney.city}
                                onCommit={newVal =>
                                    props.onFieldChange("powerOfAttorney.city", newVal)
                                }
                            />
                            <AutosavingStateInput
                                label={locale.strings.state}
                                initial={props.placement.powerOfAttorney.state}
                                onCommit={newVal =>
                                    props.onFieldChange("powerOfAttorney.state", newVal)
                                }
                            />
                            <AutosavingInput
                                label={locale.strings.zip}
                                initial={props.placement.powerOfAttorney.zip}
                                onCommit={newVal =>
                                    props.onFieldChange("powerOfAttorney.zip", newVal)
                                }
                            />
                        </div>
                    </div>
                )}
            </LocaleContext.Consumer>
        );
    }

    let poaIsBestContact = <span />;
    if (props.placement.hasPowerOfAttorney) {
        poaIsBestContact = (
            <div id="poa-same-as-best-contact" className="flex-column">
                <Checkbox
                    checked={props.placement.powerOfAttorneySameAsBestContact}
                    label="Same As Best Contact Above?"
                    onChange={newVal =>
                        props.onFieldChange(
                            "powerOfAttorneySameAsBestContact",
                            newVal.target.checked,
                        )
                    }
                />
            </div>
        );
    }

    return (
        <InputFormBlock>
            <Header iconName="35_PowerOfAttorney">Power of attorney</Header>
            <div className="flex-row">
                <div className="flex-column">
                    <Checkbox
                        label="Has Power Of Attorney?"
                        checked={props.placement.hasPowerOfAttorney}
                        onChange={newVal =>
                            props.onFieldChange("hasPowerOfAttorney", newVal.target.value)
                        }
                    />
                </div>
                {poaIsBestContact}
            </div>
            {poaForm}
        </InputFormBlock>
    );
};
